import { useRef } from "react";
import styled from "styled-components";

import Btn from "components/atoms/buttons";
import { TextSm } from "components/atoms/text";
import COLORS from "components/atoms/colors";

import { InputChange } from "types/Form";
import Action from "types/Action";

import useUpload from "apis/mutations/useUpload";

interface Props {
  file?: string;
  name: string;
  onDispatch: (option: Action["option"]) => void;
}

const InputFile = ({ file, name, onDispatch }: Props) => {
  const ref = useRef<HTMLInputElement>(null);

  const upload = useUpload({
    onSuccess: (image) => onDispatch({ key: "license", value: image }),
  });

  const handleChange = (event: InputChange) => {
    const selectedFiles = event.target.files;
    if (!selectedFiles) return;
    upload(selectedFiles[0]);
  };

  const fileName = file?.split("/").at(-1);

  return (
    <div>
      <input
        ref={ref}
        name={name}
        type="file"
        className="hidden"
        onChange={handleChange}
        accept="image/*"
      />

      {file ? (
        <div className="flex gap-3 items-center">
          <FileNameWrap>
            <TextSm>{fileName}</TextSm>
          </FileNameWrap>
          <Btn.Blue
            onClick={() => ref?.current?.click()}
            type="button"
            size="large"
            radiusFull
            width="100px"
            className="flex-none"
          >
            수정
          </Btn.Blue>
        </div>
      ) : (
        <Btn.Blue
          onClick={() => ref?.current?.click()}
          type="button"
          size="large"
          radiusFull
          width="100%"
        >
          첨부하기
        </Btn.Blue>
      )}
    </div>
  );
};

const FileNameWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  height: 44px;
  padding: 12px;
  border-radius: 44px;
  border: 1px solid ${COLORS.black["100%"]};
  background: #fff;
`;

export default InputFile;
